import { styled } from '@linaria/react';

import { colors, fonts, layout, space } from '../../theme/tokens';

export const ContentColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 0;
`;

export const FormArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
`;

export const FormPanel = styled.div`
  --voyager-signin-title-gap: ${space[5]};
  --voyager-signin-header-gap: ${space[5]};
  --voyager-signin-form-gap: ${space[5]};
  --voyager-signin-heading-size: ${fonts.size['2xl']};
  --voyager-signin-heading-weight: ${fonts.weight.normal};
  --voyager-signin-heading-tracking: -0.5px;
  --voyager-signin-subtitle-size: ${fonts.size.base};
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    --voyager-signin-heading-size: ${fonts.size['3xl']};
  }

  & button[type='submit'] {
    height: 56px;
    border-radius: ${layout.borderRadiusFull};
    font-size: ${fonts.size.base};
  }

  & input:not([type='checkbox']) {
    height: 72px;
    border-radius: ${layout.borderRadiusLg};
    font-size: ${fonts.size.base};
    padding: 0 ${layout.horizontalPadding};
  }
`;

export const SuccessMessage = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  color: ${colors.fontPrimary};
  text-align: center;
  line-height: 1.6;
  margin: 0;
  width: 100%;
`;
